import { render } from "./blackListDatabase.vue?vue&type=template&id=1fd4609a&scoped=true"
import script from "./blackListDatabase.vue?vue&type=script&lang=js"
export * from "./blackListDatabase.vue?vue&type=script&lang=js"

import "./blackListDatabase.vue?vue&type=style&index=0&id=1fd4609a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1fd4609a"

export default script